import * as React from 'react';
import { Route } from 'react-router';
import { makeGetComponent } from './utils';

export const getAntRootRoute = () => (
  <Route getComponent={makeGetComponent('antd/AntRoot')}>
    {/* "/product" and "/products" */}
    <Route
      path="product(s)"
      getComponent={makeGetComponent('SearchProductsPublicPage/index')}
    />
    <Route
      path="cart"
      getComponent={makeGetComponent('CartCheckoutPage/index')}
    />
    <Route
      path="new-trade-form"
      getComponent={makeGetComponent('NewTradeFormPage/index')}
    />
  </Route>
);



// WEBPACK FOOTER //
// ./app/routers/AntRootRoute.tsx